import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';
import { LoadingState } from './LoadingState';

export const RequestMedia = lazyWithSuspense(async () => import('./RequestMediaScreen'), {
  loadingState: <LoadingState />,
});
